jQuery(document).ready(function ($) {
    "use strict";

    var awardsContainer = $('#awardslisting');

    awardsContainer.imagesLoaded( function() {
        awardsContainer.isotope({
            layoutMode: 'vertical',
            itemSelector: '.award-listings__grid'
        });
    });

    $('#awardsfilters').on( 'click', 'a', function(e) {
        e.preventDefault();
        var filterValue = '.' + $(this).attr('data-filter');
        awardsContainer.isotope({ filter: filterValue });

        $(this).siblings().removeClass('inactive active').addClass('inactive');
        $(this).removeClass('inactive active').addClass('active');
    });

});
